import { render } from "./LoginBranding.vue?vue&type=template&id=17f5fb62&scoped=true"
import script from "./LoginBranding.vue?vue&type=script&lang=js"
export * from "./LoginBranding.vue?vue&type=script&lang=js"

import "./login-layout.scss?vue&type=style&index=0&id=17f5fb62&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f5fb62"]])

export default __exports__